/** Shown by the top-level Sentry error boundary if the app crashes with an uncaught render error, instead of a blank white screen. Matches the style of the app's other full-page states (see App.tsx's signed-out/Rise-redirect/error screens). */
export default function ErrorFallback() {
  return (
    <div className="app-shell">
      <div className="centered-screen">
        <div className="centered-card">
          <h1 className="di-h4">Something went wrong</h1>
          <p className="di-p">
            This page hit an unexpected error. Reloading usually fixes it -- if it keeps happening,
            let Cam know what you were doing when it happened.
          </p>
          <button className="di-btn di-btn-primary" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    </div>
  );
}
